<template>
    <el-dialog
        title="选择车间"
        :visible.sync="visible"
        width="400px"
        :before-close="befclose">
        <div>
            <el-input class="input search" prefix-icon="el-icon-search" size="small" v-model="keywords" @keyup.native="handleSearch" placeholder="请输入车间"/>
            <el-radio-group v-model="info" v-if="infoList.length > 0">
                <el-row :gutter="20" v-for="(data,index) in infoListCopy" :key="index" :class="{'background-row-choose':data.workshopCode==info.workshopCode}">
                    <el-col :span="24">
                        <el-radio :label="data">{{data.workshopName}}</el-radio>
                    </el-col>
                </el-row>
            </el-radio-group>
            <div class="noData" v-else>
                <div>暂未查找到车间</div>
                <!-- <el-button class="add" size="small" type="primary" icon="el-icon-plus" @click="openAddInfoProject()">新增项目信息</el-button> -->
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="handleConfirm">下一步</el-button>
        </span>
        
    </el-dialog>
    
</template>
<script>
import { crmApi } from "@/services";
import { networkInterfaces } from 'os';
const R = require("ramda");
export default {
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        infoList: {
            type: Array,
            required: true
        },
        infoObject: {
            type: Object
        }
    },
    data() {
        return {
            keywords: "",
            info: {},
            addInfoProjectShow:false,
            infoListCopy:this.infoList
        };
    },
    computed:{
    },
    watch: {
        infoList(newValue, oldValue){
            for(let data of newValue){
                if(data.workshopCode == this.infoObject.workshopCode){
                    this.info =  data;
                    return;
                }
            }
            this.infoListCopy = this.infoList;
            
        },
        infoObject(newValue,oldValue){
            if(JSON.stringify(newValue) == "{}"){
                this.info = {};
            }else{
                for(let data of this.infoListCopy){
                    if(data.workshopCode == newValue.workshopCode){
                        this.info =  data;
                        return;
                    }
                }
            }
            
        }
    },
    methods: {
        handleSearch() {
            // this.$emit("handleSearch", this.keywords);
            this.infoListCopy =  this.infoList.filter((item,index,arr)=>{
                if(this.keywords.length == 0){
                    return item;
                }else{
                    return item.workshopName.indexOf(this.keywords) != -1; 
                }
                
            })
        },
        handleCancel() {
            this.$emit("handleCancel");
        },
        handleConfirm() {
            this.$emit("handleConfirm",this.info);
        },
        befclose() {
            this.$emit("befclose");
        },
        openAddInfoProject() {
            this.$emit("befclose","add");
            
        },
        close(){
            this.addInfoProjectShow = false;
        }
    },
    created(){
    }
};
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
    /deep/.el-dialog__header {
        padding: 21px 0px 18px 23px;
        border-bottom: 1px solid #dcdfe5;
    }
    /deep/.el-dialog__title {
        color: #323232;
    }
    /deep/.el-dialog__body {
        min-height: 320px;
        padding: 10px 20px;
        .add {
            margin-top: 5px;
            background: #fff;
            color: #409eff;
        }
        .noData {
            text-align: center;
            margin-top: 65px;
        }
        .search {
            margin-bottom: 10px;
            /deep/.el-input__inner {
                line-height: 33px;
            }
            .el-input__inner::-webkit-input-placeholder{
                font-size: 12px;
            }
        }
        
        
        .el-radio-group {
            display: block;
            max-height: 300px;
            overflow-y: auto;
            overflow-x: hidden;
            .background-row-choose {
                background: #f5f5f5;
            }
            .el-row {
                padding: 22px 10px;
                .el-radio__input.is-checked .el-radio__inner {
                    border-color: #ed2e3d;
                    background: #ed2e3d;
                }
                .el-radio__input.is-checked + .el-radio__label {
                    color: #323232;
                }
                .el-radio__label{
                    vertical-align: middle;
                }
                .el-radio__inner {
                    width: 16px;
                    height: 16px;
                }
            }
        }
    }
}
</style>
